import React from "react";

var HomeIcon = function HomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 9.163L12 0 .8 9.163a2.185 2.185 0 0 0-.8 1.689v10.966C0 23.023.977 24 2.182 24H8v-6a4 4 0 0 1 8 0v6h5.818A2.182 2.182 0 0 0 24 21.818V10.852c0-.654-.294-1.274-.8-1.689z"
  }));
};

HomeIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
HomeIcon.defaultProps.solid = true;
export default HomeIcon;